// extracted by mini-css-extract-plugin
module.exports = {"superElipse":"super-ellipse-skins-mediumOnWide-superElipse-60e2e263","strokeWidth":"super-ellipse-skins-mediumOnWide-strokeWidth-b113d8cf"};